import {Button} from 'primereact/button'
import {Password} from 'primereact/password'
import {useState} from 'react'
import {HTTP_STATUS_OK} from '../../Constants'
import TranslateUtils from '../../i18n/TranslateUtils'
import {openPage} from '../../utils/NavigatorUtils'
import {changePassword} from '../authentication/AuthEndPoints'
import {useAuth} from '../authentication/AuthProvider'
import {securityList} from '../information/ProfileConstant'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'

const Security = () => {
    const {translateKeys} = TranslateUtils()
    const {user} = useAuth()

    const [formData, setFormData] = useState({})
    const [editField, setEditField] = useState(null)
    const [tempValue, setTempValue] = useState('')
    const [isCancelling, setIsCancelling] = useState(false)

    const startEdit = key => {
        setIsCancelling(false)
        setEditField(key)
        setTempValue(formData[key] || '')
    }

    const saveEdit = key => {
        setFormData({...formData, [key]: tempValue})
        setEditField(null)
    }

    const cancelEdit = () => {
        setIsCancelling(true)
        setEditField(null)
        setTempValue('')
    }

    const renderInput = item => (
        <Password
            value={tempValue}
            onChange={e => setTempValue(e.target.value)}
            feedback={false}
            toggleMask
            className="p-password"
            onBlur={() => {
                if (!isCancelling) saveEdit(item.key)
            }}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                    e.preventDefault()
                    if (!isCancelling) saveEdit(item.key)
                }
            }}
        />
    )

    const handleOnSubmit = async () => {
        if (formData.newPassword !== formData.retypePassword) {
            showNotification(
                severityNotification.error,
                'Passwords do not match!',
            )
            return
        }

        const toPostData = {
            ...formData,
            usernameOrEmail: user?.email ? user.email : user?.username,
        }

        const responseStatus = await changePassword(toPostData)
        if (responseStatus === HTTP_STATUS_OK) {
            showNotification(
                severityNotification.success,
                'Change password successfully !',
            )
            openPage('/')
        }
    }

    return (
        <div className="security-detail-container w-full">
            {securityList[0].children.map(item => (
                <div key={item.key} className="profile-row">
                    <div className="profile-label">
                        {translateKeys(item.placeholder)}
                    </div>

                    <div className="profile-value">
                        {editField === item.key
                            ? renderInput(item)
                            : formData[item.key]
                            ? '********'
                            : '-'}
                    </div>

                    <div className="profile-action">
                        {editField === item.key ? (
                            <Button
                                label="Cancel"
                                onMouseDown={() => {
                                    setIsCancelling(true)
                                    cancelEdit()
                                }}
                            />
                        ) : (
                            <span onClick={() => startEdit(item.key)}>
                                Edit
                            </span>
                        )}
                    </div>
                </div>
            ))}

            <div className="mt-4">
                <Button
                    className="w-full"
                    icon="pi pi-send"
                    label="SUBMIT"
                    onClick={handleOnSubmit}
                />
            </div>
        </div>
    )
}

export default Security
